export enum DesiredVisibility {
  Private = 0,
  Internal = 1,
  Public = 2,
  PrivateLocked = -1,
}
